/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import Emails from './Emails/index'
import Heading from './Heading/index'
import NewEmail from './NewEmail/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email"
  
}) {
  return (<React.Fragment
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
<NewEmail
  viewPath={`${viewPath}/NewEmail`}
/>
{children}
</React.Fragment>)
}